/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    export interface IReportDrawerHistoryListItem {
        drawer_TId?: string;
        displayName: string;
        openByUserDisplayName: string
        closeByUserDisplayName: string;
        openDateTime: Date;
        closeDateTime: Date;
        openCashAmount: number;
        closeCashAmount: number;
        isSelected?: boolean;
    }

    interface IOpenCloseHistoryController {
        openOnDate: Date;
        closeOnDate: Date;
        openOnTime: Date;
        closeOnTime: Date;
        securityAccess: SecurityAccessEnum;
        disabled: boolean;
        model: string[];
        modelKey: string;
        init(): void;
        openModalWindow(): void;
    }

    export class OpenCloseHistoryController implements IOpenCloseHistoryController {
        static $inject = [
            'meevo.components.common.DataService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService',
            'meevo.AppSettings',
            '$rootScope',
        ];

        // comes from directive's scope
        public openOnDate: Date;
        public closeOnDate: Date;
        public openOnTime: Date;
        public closeOnTime: Date;
        public securityAccess: SecurityAccessEnum;
        public disabled: boolean;
        public model: string[];
        public modelKey: string;
        public showSeconds: boolean;
        public showAmPm: boolean;
        private list: Array<IReportDrawerHistoryListItem>;

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private modalService: Meevo.Components.Modal.IModalService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private $rootScope: ng.IRootScopeService
        ) {
        }

        /**
         * Initialize directive
         */
        init(): void {}

        /**
         * Open Modal Window
         */
        openModalWindow(): void {
            this.busyService.start();
            this.dataService.getListPaged(`${this.appSettings.API_ENDPOINTS.report}/DrawerHistory`, {
                itemsPerPage: 10000
            })
                .then((response: Array<IReportDrawerHistoryListItem>) => {
                    this.list = response;

                    let options: Meevo.Components.Modal.IModalOptions = {
                        controller: 'meevo.components.controls.openCloseHistoryModalController',
                        bindToController: true,
                        controllerAs: 'vm',
                        templateUrl: 'app/components/controls/openCloseHistory/modal/openCloseHistory.modal.html',
                        escapeToClose: false,
                        locals: {
                            list: this.list,
                            showAmPm: this.showAmPm,
                            showSeconds: this.showSeconds
                        }
                    }
                    this.modalService.showCustom(options).then((selectedItem: IReportDrawerHistoryListItem) => {
                        if (selectedItem) {
                            if(this.model) {
                                this.model.length = 0;
                                this.model.push(selectedItem[this.modelKey]);
                                this.$rootScope.$broadcast('openCloseHistoryModelValueSet');
                            }

                            this.openOnDate = selectedItem.openDateTime || new Date();
                            this.closeOnDate = selectedItem.closeDateTime || new Date();

                            this.openOnTime = angular.copy(this.openOnDate);
                            this.closeOnTime = angular.copy(this.closeOnDate);
                        }
                    });
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }
    }
}